// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"98":"0e33869d81cb4d36","473":"70deb59cbee34b13","888":"86d1d0bc1d270b4e","899":"a164d241288ff9b6"}[chunkId] + ".css";
};